// extracted by mini-css-extract-plugin
module.exports = {"root":"formattedText_root__2jMAG"};